export default class RowFeedback {
	constructor(rowId, apiRef) {
		this.rowId = rowId || null;
		this.apiRef = apiRef || null;
		this.node = null;
	}

	/**
	 * @description Initialize the class to use it as static method
	 * @param rowId
	 * @param apiRef
	 * @returns static class
	 */
	static skeleton(rowId, apiRef) {
		try {
			return new RowFeedback(rowId, apiRef);
		} catch (error) {
			console.log(error);
		}
	}

	/**
	 * @description Display the skeleton for current row.
	 * use it for SAVE and UPDATE actions.
	 * eg: RowFeedback.skeleton(rowId, apiRef).display()
	 *
	 * @returns Object
	 */
	display() {
		try {
			add(this, ["skelton-row"]);
			return true;
		} catch (error) {
			return false;
		}
	}

	/**
	 * @description Creates a row.
	 * use it when there is not a button action to add a new Row
	 * eg: RowFeedback.skeleton(rowId, apiRef).create().display()
	 *
	 * @returns Object
	 */
	create() {
		try {
			let row = {
				id: this.rowId,
			};
			row["id"] = this.rowId;

			this.apiRef.current.updateRows([row]);
			this.apiRef.current.setRowMode(this.rowId, "view");

			setTimeout(() => {
				this.apiRef.current.scrollToIndexes({
					rowIndex: this.apiRef.current.getRowsCount() - 1,
				});
			});

			return this;
		} catch (error) {
			return false;
		}
	}

	/**
	 * @description Removes the skeleton from the current row && sets the row in View mode.
	 * This should be used on SUCCESS for SAVE and UPDATE actions.
	 * eg: RowFeedback.skeleton(rowId, apiRef).success()
	 *
	 * @returns Boolean
	 */
	success() {
		try {
			remove(this, ["skelton-row"]);
			this.apiRef.current.setRowMode(this.rowId, "view");
			return true;
		} catch (error) {
			return false;
		}
	}

	/**
	 * @description Removes the skeleton from the current row && sets the row in Edit mode.
	 * This should be used on Error for Save and Update actions.
	 * eg: RowFeedback.skeleton(rowId, apiRef).error()
	 *
	 * @returns Boolean
	 */
	error() {
		try {
			remove(this, ["skelton-row"]);
			this.apiRef.current.setRowMode(this.rowId, "edit");
			return true;
		} catch (error) {
			return false;
		}
	}

	/**
	 * @description Display the skeleton for DELETE action only.
	 * This should be used with display() in a chain fashion.
	 * eg: RowFeedback.skeleton(rowId, apiRef).delete().display()
	 *
	 * @returns Object || null
	 */
	delete() {
		try {
			this.node = addAndRemove(this, ["skelton-row-delete"], ["Mui-selected"]);
		} catch (error) {
			return null;
		}

		return this;
	}

	/**
	 * @description Remove skeleton && row for a successful deletion.
	 * This should be used on SUCCESS for DELETE action.
	 * eg: RowFeedback.skeleton(rowId, apiRef).successDelete()
	 * disabled TRUE:  use it in onSuccess callback. The row will be disabled
	 * disabled FALSE: use it in onSuccess callback. The row will be removed.
	 * eg: RowFeedback.skeleton().successDelete(true);
	 *
	 * @param disabled Boolean
	 * @returns Boolean
	 */
	successDelete(disabled = false) {
		try {
			if (disabled) {
				const elements = Array.prototype.slice.call(document.getElementsByClassName("skelton-row-delete skelton-row"));
				elements?.length && elements.forEach((ele) => ele.classList.remove("skelton-row", "skelton-row-delete"));
			} else {
				this.apiRef.current.updateRows([{ id: this.rowId, _action: "delete" }]);
			}

			return true;
		} catch (error) {
			console.log(error);
			return false;
		}
	}

	/**
	 * @description Removes the skeleton && set the row in VIEW mode.
	 * This should be used on ERROR for DELETE action.
	 * eg: RowFeedback.skeleton(rowId, apiRef).errorDelete()
	 *
	 * @param disabled Boolean
	 * @returns Boolean
	 */
	errorDelete(disabled = false) {
		try {
			if (disabled) {
				const elements = Array.prototype.slice.call(document.getElementsByClassName("skelton-row-delete skelton-row"));
				elements?.length && elements.forEach((element) => element.classList.remove("skelton-row", "skelton-row-delete"));
			} else {
				addAndRemove(this, ["Mui-selected"], ["skelton-row", "skelton-row-delete"]);
				this.apiRef.current.setRowMode(this.rowId, "view");
			}

			return true;
		} catch (error) {
			return false;
		}
	}
}

const add = (obj, classNames) => {
	const elNode = obj.node ? obj.node : obj.apiRef.current.getRowElement(obj.rowId);
	classNames.forEach((className) => elNode.classList.add(className));
	return elNode;
};

const remove = (obj, classNames) => {
	const elNode = obj.apiRef.current.getRowElement(obj.rowId);
	classNames.forEach((className) => elNode.classList.remove(className));
	return elNode;
};

const addAndRemove = (obj, classesToAdd, classesToRemove) => {
	const elNode = obj.apiRef.current.getRowElement(obj.rowId);
	add(obj, classesToAdd);
	remove(obj, classesToRemove);
	return elNode;
};
